module.exports = __webpack_public_path__ + "static/media/ethereum@2x.b514aca0.png";